import { Link } from 'react-router-dom'
import './FooterLogo.css'

const HouseIcon = () => (
  <svg className="footer-logo__icon" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M20 4L4 18v16h8V22h16v12h8V18L20 4z" fill="#e84e60" />
    <path d="M20 4l-4 3.5V10h8V7.5L20 4z" fill="#f25b6a" opacity="0.9" />
  </svg>
)

function FooterLogo({ brand, variant = 'light', centered = false }) {
  const mainText = brand?.name || 'Probando.'
  const subText = brand?.tagline || 'Automotora'

  return (
    <Link to="/" className={`footer-logo footer-logo--${variant} ${centered ? 'footer-logo--centered' : ''}`}>
      {brand?.logo ? (
        <img src={brand.logo} alt={mainText} className="footer-logo__img" />
      ) : (
        <>
          <HouseIcon />
          <span className="footer-logo__text">
            <span className="footer-logo__main">{mainText}</span>
            <span className="footer-logo__sub">{subText}</span>
          </span>
        </>
      )}
    </Link>
  )
}

export default FooterLogo
